module.exports = __webpack_public_path__ + "img/Cize.8676472e.png";